import { render, staticRenderFns } from "./SignatureForm.vue?vue&type=template&id=49917c16&scoped=true"
import script from "./SignatureForm.vue?vue&type=script&lang=js"
export * from "./SignatureForm.vue?vue&type=script&lang=js"
import style0 from "./SignatureForm.vue?vue&type=style&index=0&id=49917c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49917c16",
  null
  
)

export default component.exports